import React, { Component } from 'react'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import MomentUtils from 'material-ui-pickers/utils/moment-utils'
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
import { Redirect, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import 'styles/bootstrap.scss'
import 'styles/app.scss'
import defaultTheme from './themes/defaultTheme'
import AppLocale from '../lngProvider'

import MainApp from 'app/index'
import asyncComponent from 'util/asyncComponent'

import Notifications from './Notifications'

class App extends Component {
  render () {
    const {match, location, locale} = this.props
    if (location.pathname === '/') {
      return ( <Redirect to={'/script-log'}/> )
    }
    let applyTheme = createMuiTheme(defaultTheme)

    const currentAppLocale = AppLocale[locale.locale]
    return (
      <MuiThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}>
            <div className="app-main">
              <Switch>
                <Route path={`${match.url}`} component={MainApp}/>
                <Route
                  component={asyncComponent(() => import('components/Error404'))}/>
              </Switch>
              <Notifications/>
            </div>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    )
  }
}

const mapStateToProps = ({settings}) => {
  const {sideNavColor, locale, isDirectionRTL} = settings
  return {sideNavColor, locale, isDirectionRTL}
}

export default connect(mapStateToProps)(App)




// WEBPACK FOOTER //
// ./containers/App.js